import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const fallbackRanges = [
    { min: 0, max: 2, color: '#d32f2f' },        // red
    { min: 2, max: 5, color: '#f57c00' },         // orange
    { min: 5, max: 10, color: '#fbc02d' },        // yellow
    { min: 10, max: 20, color: '#388e3c' },       // green
    { min: 20, max: Infinity, color: '#1976d2' },  // blue
];

function buildFlowRateRanges(targetRate) {
    if (!targetRate || targetRate <= 0) return fallbackRanges;

    const t = targetRate;
    return [
        { min: 0,       max: t * 0.5, color: '#d32f2f' },   // red
        { min: t * 0.5, max: t * 0.7, color: '#f57c00' },   // orange
        { min: t * 0.7, max: t * 0.9, color: '#fbc02d' },   // yellow
        { min: t * 0.9, max: t * 1.1, color: '#388e3c' },   // green
        { min: t * 1.1, max: t * 1.3, color: '#1976d2' },   // blue
        { min: t * 1.3, max: t * 1.5, color: '#3f51b5' },   // indigo
        { min: t * 1.5, max: Infinity, color: '#7b1fa2' },   // purple
    ];
}

const legendFormatter = r =>
    r.max === Infinity
        ? `${r.min.toFixed(1)}+`
        : `${r.min.toFixed(1)} - ${r.max.toFixed(1)}`;

export default function ApplicationRateOverlay({ routes, tractor }) {
    const allPoints = useMemo(() => routes.flat(), [routes]);
    const flowRateRanges = useMemo(
        () => buildFlowRateRanges(tractor?.defaultTargetApplicationRateGalAcre),
        [tractor?.defaultTargetApplicationRateGalAcre]
    );

    const targetRate = tractor?.defaultTargetApplicationRateGalAcre;
    const legendTitle = targetRate && targetRate > 0
        ? <>Application Rate (gal/ac)<br /><span style={{ fontSize: '0.9em', fontWeight: 'normal' }}>Target: {targetRate.toFixed(1)} gal/ac</span></>
        : "Application Rate (gal/ac)";

    if (!allPoints.length) return null;

    return (
        <SegmentedPolylineOverlay
            segments={routes}
            valueSelector={pt => pt.appRateGalPerAc >= 0 ? pt.appRateGalPerAc : 0}
            ranges={flowRateRanges}
            legendTitle={legendTitle}
            legendFormatter={legendFormatter}
            units="gal/ac"
            discrete={false}
        />
    );
}